import React from 'react';
import { SvgClose } from '../../../icons';
import css from './close-button.module.scss';

interface CloseButtonProps {
  onClick: () => void;
  position?: 'start' | 'end';
  icon?: JSX.Element;
}

export function CloseButton({ onClick, icon, position = 'end' }: CloseButtonProps) {
  return (
    <button className={css.button} onClick={onClick} data-position={position}>
      {icon || <SvgClose />}
    </button>
  );
}
